<!-- <h2 mat-dialog-title>Warning!</h2> -->
<mat-dialog-content [innerHTML]="data.message"></mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="onYesClick()">Yes</button>
    <button color="primary" mat-raised-button mat-dialog-close (click)="onNoClick()">No</button>
</mat-dialog-actions>
